import React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { AdminWaitingList } from '../../components/AdminWaitingList/AdminWaitingList'

export const Route = createFileRoute('/admin/waiting-list')({
    component: () => (
        <AdminWaitingList />
    ),
})
